import dayjs from "dayjs";

export const groupBy = function <T>(xs: T[], key): { [key in string]: T[] } {
	return xs.reduce(function (rv, x) {
		(rv[x[key]] ??= []).push(x);
		return rv;
	}, {});
};

export const stripHtmlTags = (htmlString: string): string => {
	return htmlString.replace(/<[^>]*>/g, "");
};

export const generateTitleFromPath = (path: string): string => {
	const segments = path.split("/").filter(Boolean);
	const last = segments.at(-1) || "";
	const type = segments.at(-2);
	const name = last
		.split("-")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join("-");

	switch (type) {
		case "brand":
			return `برند ${name}`;
		case "collection":
			return `کالکشن ${name}`;
		case "products":
			return `محصول ${name}`;
		default:
			return name;
	}
};

export function trimText(text, maxLength = 160) {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    const clean = text.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ");
    if (clean.length <= maxLength) return clean;
    const sliced = clean.slice(0, maxLength);
    const lastSpace = sliced.lastIndexOf(" ");
    return (lastSpace > 0 ? sliced.slice(0, lastSpace) : sliced).trim() + "…";
}

export const calcFromNow = (datetime: string) => {
	return dayjs(datetime, "YYYY-MM-DD HH:mm:ss").locale("fa").fromNow();
};
